import { createContext } from 'react';

const ReqInContext = createContext({

});

export default ReqInContext;
